import { render, staticRenderFns } from "./partnerStyleList.vue?vue&type=template&id=b9977e7e&scoped=true&"
import script from "./partnerStyleList.vue?vue&type=script&lang=js&"
export * from "./partnerStyleList.vue?vue&type=script&lang=js&"
import style0 from "./partnerStyleList.vue?vue&type=style&index=0&id=b9977e7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9977e7e",
  null
  
)

export default component.exports